// src/components/MicrophoneButton/index.tsx
import React, { useContext } from "react";
import { InterviewContext } from "src/contexts/InterviewContext";

import micIcon from "../../../../assets/images/mic.svg";
// import { Button } from "../../../../components/ui/Button"; // <-- Update the import path if needed

interface MicrophoneButtonProps {
  isActive?: boolean;
  // Accept either a synchronous or async function
  onClick?: () => void | Promise<void>;
  isTutorial?: boolean;
}

const MicrophoneButton: React.FC<MicrophoneButtonProps> = ({
  isActive = true,
  onClick,
  isTutorial,
}) => {
  const { finishAnsweringHandler } = useContext(InterviewContext)!;

  const handleMicrophoneClick = async () => {
    if (isActive) {
      if (isTutorial) {
        if (onClick) {
          await onClick();
        }
        console.log("Tutorial microphone button clicked!");
        return;
      }
      await finishAnsweringHandler(false);
      console.log("Finish Talking clicked!");
      if (onClick) {
        await onClick();
      }
    } else {
      console.log("Interviewer is speaking. Please listen.");
    }
  };

  return isActive ? (
    <button
      onClick={handleMicrophoneClick}
      aria-label="Microphone Active"
      // Tailwind classes to replicate the .microphoneButton look
      className="
      flex items-center justify-center relative text-white border-none
        px-4 py-2  rounded-[8px] flex-shrink-0
        after:content-[''] after:absolute after:inset-0 after:rounded-[8px]
        after:pointer-events-none after:opacity-20
        after:bg-[radial-gradient(266.28%_88.31%_at_97.2%_100%,_rgba(255,255,255,0.20)_0%,_rgba(255,255,255,0)_100%)]
        text-[1rem]
        
       
      "
      style={{
        backgroundColor: "var(--color-primary)",
      }}
    >
      <img className="w-[1.25rem] h-[1.25rem]" src={micIcon} />
      <div className="ml-2">Finish Talking</div>
    </button>
  ) : (
    <button
      aria-label="Microphone Inactive"
      // Tailwind classes to replicate the .microphoneButtonInactive look
      className="
      flex
        items-center
        justify-center
        relative 
        text-[#b8bbc2]
        bg-[#f1f2f3] 
       
        rounded-[8px] px-4 py-2 
       
         text-[1rem]

      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 15 20"
        fill="none"
      >
        <path
          d="M7.36842 12.6316C6.48271 12.6316 5.72986 12.3246 5.10986 11.7105C4.48987 11.0965 4.17987 10.3509 4.17987 9.47368V3.15789C4.17987 2.2807 4.48987 1.53509 5.10986 0.921053C5.72986 0.307018 6.48271 0 7.36842 0C8.25413 0 9.00698 0.307018 9.62698 0.921053C10.247 1.53509 10.557 2.2807 10.557 3.15789V9.47368C10.557 10.3509 10.247 11.0965 9.62698 11.7105C9.00698 12.3246 8.25413 12.6316 7.36842 12.6316ZM6.30557 18.9474V16.7632C4.67586 16.5351 3.28087 15.8509 2.12059 14.7105C0.960313 13.5702 0.256174 12.1842 0.00817578 10.5526C-0.0272526 10.2544 0.0524613 10 0.247317 9.78947C0.442173 9.57895 0.690172 9.47368 0.991313 9.47368C1.29245 9.47368 1.54488 9.57456 1.74859 9.77632C1.95231 9.97807 2.08959 10.2281 2.16045 10.5263C2.40845 11.7544 3.02402 12.7632 4.00715 13.5526C4.99029 14.3421 6.11071 14.7368 7.36842 14.7368C8.64384 14.7368 9.76869 14.3377 10.743 13.5395C11.7173 12.7412 12.3284 11.7368 12.5764 10.5263C12.6472 10.2281 12.7845 9.97807 12.9882 9.77632C13.192 9.57456 13.4444 9.47368 13.7455 9.47368C14.0467 9.47368 14.2947 9.57895 14.4895 9.78947C14.6844 10 14.7641 10.2544 14.7287 10.5526C14.4807 12.1491 13.781 13.5263 12.6295 14.6842C11.4781 15.8421 10.0787 16.5351 8.43127 16.7632V18.9474C8.43127 19.2456 8.32942 19.4956 8.1257 19.6974C7.92199 19.8991 7.66956 20 7.36842 20C7.06728 20 6.81485 19.8991 6.61114 19.6974C6.40743 19.4956 6.30557 19.2456 6.30557 18.9474ZM7.36842 10.5263C7.66956 10.5263 7.92199 10.4254 8.1257 10.2237C8.32942 10.0219 8.43127 9.77193 8.43127 9.47368V3.15789C8.43127 2.85965 8.32942 2.60965 8.1257 2.4079C7.92199 2.20614 7.66956 2.10526 7.36842 2.10526C7.06728 2.10526 6.81485 2.20614 6.61114 2.4079C6.40743 2.60965 6.30557 2.85965 6.30557 3.15789V9.47368C6.30557 9.77193 6.40743 10.0219 6.61114 10.2237C6.81485 10.4254 7.06728 10.5263 7.36842 10.5263Z"
          fill="#B8BBC2"
        />
      </svg>
      <div className="ml-2">Please Wait</div>
    </button>
  );
};

export default MicrophoneButton;
